import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { interval, startWith, Subject, takeUntil } from 'rxjs';
import { SignalModel } from '@irian-ro/util-signal';
import { translationSchema } from '@well/translation';
import { ProgressBar, ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'well-payment-method-pending-view',
  standalone: true,
  imports: [CommonModule, ProgressBarModule, TranslateModule, ButtonModule],
  templateUrl: './payment-method-pending-view.component.html',
  styleUrls: ['./payment-method-pending-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentMethodPendingViewComponent implements OnDestroy{

  @Input() readonly waitingSecondsWithNoWarning: number = 60;
  @Output() checkStatus: EventEmitter<void> = new EventEmitter<void>();
  @Output() retryPayment: EventEmitter<void> = new EventEmitter<void>();
  paymentStatusSignal: SignalModel<string | null> = new SignalModel<string | null>(null);
  afterTimeoutSignal: SignalModel<boolean> = new SignalModel<boolean>(false);
  loadingSignal: SignalModel<boolean> = new SignalModel<boolean>(false);
  showWarning = computed(() => {

    if(this.paymentStatusSignal.signal() === 'NEW' || this.paymentStatusSignal.signal() === null){
      return this.afterTimeoutSignal.signal();
    }

    return false;

  })
  showBar = computed(() => {
    if(this.paymentStatusSignal.signal() === 'NEW' || this.paymentStatusSignal.signal() === null){
      return true;
    }

    if(this.paymentStatusSignal.signal() === 'PENDING'){
      return this.loadingSignal.signal();
    }

    return false;
  })
  protected readonly translationSchema = translationSchema;
  private _timeoutId: number | null = null;

  private _unsubscribePooling: Subject<boolean> = new Subject<boolean>();

  @Input() set paymentStatus(value: string | null){
    this.paymentStatusSignal.value = value;

    if((value === 'NEW' || value === null) && this._timeoutId === null){
      this.startTimerAndPooling();
    }

    else if ((value !== 'NEW' && value !== null) && this._timeoutId !== null){
      this.stopTimerAndPooling();
    }
  }

  onRetryPaymentClick(){
    this.retryPayment.emit();
  }

  onRefreshClick(){
    this.loadingSignal.value = true;

    setTimeout(() => {
      this.checkStatus.emit();
      this.loadingSignal.value = false;
    }, 3000);
  }

  ngOnDestroy() {
    this._unsubscribePooling.next(true);
  }

  private subscribeToRefreshSubject(){
    interval(5000)
      .pipe(
        startWith(0),
        takeUntil(this._unsubscribePooling)
      )
      .subscribe(() => {
        this.checkStatus.emit();
      })
  }

  private stopTimerAndPooling() {
    this._unsubscribePooling.next(true);
    clearTimeout(this._timeoutId!);
    this._timeoutId = null;
  }

  private startTimerAndPooling() {
    this.subscribeToRefreshSubject();
    setTimeout(() => {
        this.afterTimeoutSignal.value = true;
      },
      this.waitingSecondsWithNoWarning * 1000
    );
  }
}
